<script lang="ts" setup>
import { defineEmits } from "vue";
import { defineProps } from "vue";

import { ElSelect } from "element-plus";
import { ElOption } from "element-plus";

const {
  optionKeyKey = "key",
  optionLabelKey = "label",
  optionValueKey = "value",
  selectedOption,
  options,
} = defineProps<{
  optionKeyKey?: string;
  optionLabelKey?: string;
  optionValueKey?: string;
  selectedOption: string;
  options: { label: string; value: string; key: string }[];
}>();

const emit = defineEmits(["change"]);
const handleSelect = (value: any) => {
  emit("change", value);
};
</script>

<template>
  <ElSelect
    filterable
    default-first-option
    :model-value="selectedOption"
    @change="handleSelect"
  >
    <ElOption
      v-for="option in options"
      :key="option[optionKeyKey]"
      :value="option[optionValueKey]"
      :label="option[optionLabelKey]"
    />
  </ElSelect>
</template>
